import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";

interface UploadVideoFromUrlParams {
  fieldTypeId: string;
  videoUrl: string;
  videoName: string;
}

interface VideoUploadResponse {
  uri: string;
  name: string;
  link: string;
  player_embed_url: string;
  embed_html: string;
}

export const useUploadVideoFromUrl = () => {
  return useMutation<VideoUploadResponse, Error, UploadVideoFromUrlParams>({
    mutationFn: async ({ fieldTypeId, videoUrl, videoName }) => {
      const response = await createApiWithPath("crm").post(
        "/field-values/upload-video-from-url",
        {
          field_type_id: fieldTypeId,
          video_url: videoUrl,
          video_name: videoName,
        },
      );
      return response.data.data;
    },
  });
};
